import React, { useState } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { Card, CardBody } from "@windmill/react-ui";

import Title from "components/form/Title";
import LabelArea from "components/form/LabelArea";
import InputArea from "components/form/InputArea";
import Error from "components/form/Error";

import DrawerButton from "components/form/DrawerButton";
import useJobtitleSubmit from "hooks/useJobtitleSubmit";
import TagInputTwo from "components/common/TagInputTwo";
import { notifyError } from "utils/toast";
import SelectRole from "components/form/SelectRole";
import RangeInput from "components/form/MoneyRange";
import TextAreaCom from "components/form/TextAreaCom";
import RangeInputDualSingleField from "components/form/MoneyRange";

const JobtitleDrawer = ({ id }) => {

  const [jobType, setJobType] = useState("Fresher");
  const {
    trigger,
    register,
    handleSubmit,
    onSubmit,
    addVariant,
    variants,
    removeVariant,
    errors,
     watch,
       setValue, 
         benefits,       // <-- added
  addBenefit,     // <-- added
  removeBenefit, 
  } = useJobtitleSubmit(id, jobType, setJobType);

  const handleFormSubmit = (data) => {
   // console.log(data)
    if (variants.length === 0) {
      notifyError("Please enter the skills!");
      return;
    }
    onSubmit(data);
  };

  return (
    <>
      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        {id ? (
          <Title register={register} title="Edit Jobtitle" />
        ) : (
          <Title register={register} title="Add Jobtitle" />
        )}
      </div>
      <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
        <Card className="flex-grow scrollbar-hide w-full max-h-full">
          <CardBody>
            <form onSubmit={handleSubmit(handleFormSubmit)}>
              <div className="px-2 flex-grow scrollbar-hide w-full max-h-full pb-20">
                <div className="grid grid-cols-12 gap-5 mb-6 items-center">
                   <div className="col-span-6">
                    <LabelArea required label="Employee Role" />
                    <SelectRole
                      register={register}
                      label="Employee Role"
                      name="id_profile"
                    />
                    <Error errorName={errors.id_profile} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea label="Job Role" required />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="Job Role"
                      name="job_roles"
                      maxLength={50}
                      type="text"
                      placeholder="Job Role"
                      //  pattern={/^[A-Za-z]+$/}
                    />
                    <Error errorName={errors.job_roles} />
                  </div>

  <div className="col-span-12">
  <LabelArea label="Description" required />
  <TextAreaCom
    register={register}
    label="Description"
    name="description"
    placeholder="Enter job description"
    required={true}
  />
  <Error errorName={errors.description} />
</div>

<div className="col-span-6">
  <LabelArea label="Salary LPA" required />
 <RangeInputDualSingleField
  name="salary"
  formValue={watch("salary")}
  min={100000}
  max={800000}
  step={5000}
  setValue={setValue} // <-- important
/>

  <Error errorName={errors.salary} />
</div>


 <div className="col-span-6">
  <LabelArea label="Skills" required />
  {/* Your TagInput */}
  <TagInputTwo
    notes={variants}
    addNote={addVariant}
    removeNote={removeVariant}
    placeholder="Enter the skills"
  />

  {/* Hidden input synced with variants */}
  <input
    type="hidden"
    {...register("skills", {
      validate: () =>
        variants.length > 0 || "Please enter at least one skill",
    })}
    value={variants.join(",")} // store as comma-separated string
  />

  <Error errorName={errors.skills} />
</div>
<div className="col-span-6">
  <LabelArea label="Benefits" required />
<TagInputTwo
  notes={benefits}                // For benefits (same style as skills)
  addNote={addBenefit}
  removeNote={removeBenefit}
  placeholder="Add a benefit"
/>

  {/* Hidden input synced with benefits */}
  <input
    type="hidden"
    {...register("benefits", {
      validate: () =>
        benefits.length > 0 || "Please enter at least one benefit",
    })}
    value={benefits.join(",")}
  />

  <Error errorName={errors.benefits} />
</div>



                  <div className="col-span-6">
                    <LabelArea label="No. of Openings" required />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="No. of Openings"
                      name="no_of_openings"
                      type="number"
                      placeholder="No. of openings"
                      maxLength={3}
                      //  pattern={/^[A-Za-z]+$/}
                    />
                    <Error errorName={errors.no_of_openings} />
                  </div>

          {/* Job Type Radio */}
        <div className="col-span-6">
  <LabelArea label="Workplace Type" required />
  <div className="flex flex-row space-x-6">
    <label className="flex items-center">
      <input type="checkbox" value="On-site" {...register("workplace_type")} />
      <span className="ml-2">On-site</span>
    </label>
    <label className="flex items-center">
      <input type="checkbox" value="Remote" {...register("workplace_type")} />
      <span className="ml-2">Remote</span>
    </label>
    <label className="flex items-center">
      <input type="checkbox" value="Hybrid" {...register("workplace_type")} />
      <span className="ml-2">Hybrid</span>
    </label>
    <label className="flex items-center">
      <input type="checkbox" value="Flexible" {...register("workplace_type")} />
      <span className="ml-2">Flexible</span>
    </label>
  </div>
  <Error errorName={errors.workplace_type} />
</div>

<div className="col-span-6">
  <LabelArea label="Employment Type" required />
  <select
    {...register("employment_type", { required: "Select employment type" })}
    className="w-full px-3 py-2 border rounded-md dark:bg-gray-800 dark:border-gray-600"
  >
    <option value="">Select type</option>
    <option value="Full-time">Full-time</option>
    <option value="Part-time">Part-time</option>
  </select>
  <Error errorName={errors.employment_type} />
</div>

{/* Job Type */}

<div className="col-span-6">
  <LabelArea label="Job Type" required />

  <div className="flex items-center space-x-6 mt-2">
    <label className="flex items-center space-x-2">
      <input
        type="radio"
        name="job_type"
        value="Fresher"
        checked={jobType === "Fresher"}
        onChange={(e) => setJobType(e.target.value)}
      />
      <span>Fresher</span>
    </label>

    <label className="flex items-center space-x-2">
      <input
        type="radio"
        name="job_type"
        value="Experience"
        checked={jobType === "Experience"}
        onChange={(e) => setJobType(e.target.value)}
      />
      <span>Experienced</span>
    </label>
  </div>

  <Error errorName={errors.job_type} />
</div>

{/* Conditionally show Experience input */}
{jobType === "Experience" && (
  <div className="col-span-6">
    <LabelArea label="Experience" required />
    <InputArea
      trigger={trigger}
      register={register}
      label="Experience"
      name="years_of_exp"
      type="number"
      placeholder="experience"
      maxLength={7}
    />
    <Error errorName={errors.years_of_exp} />
  </div>
)}
<div className="col-span-6">
  <LabelArea label="Location" required />
  <InputArea
    trigger={trigger}
    register={register}
    label="Location"
    name="location"
    type="text"
    placeholder="Enter job location"
    maxLength={100}
  />
  <Error errorName={errors.location} />
</div>
                </div>
              </div>
              <DrawerButton id={id} title={id ? "Update" : "Submit"} />
            </form>
          </CardBody>
        </Card>
      </Scrollbars>
    </>
  );
};

export default JobtitleDrawer;
